var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({staticClass:"no-spin",attrs:{"dense":"","outlined":"","clearable":_vm.clearable,"type":"number","error":_vm.error,"error-messages":_vm.error_message,"hide-details":!_vm.property_state_field_name},on:{"input":function($event){return _vm.$emit('input', $event !== '' ? $event : null)}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }